import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BiolinkBtnConfig } from '../../biolink';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'upi-button',
  templateUrl: './upi-button.component.html',
  styleUrls: ['./upi-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpiButtonComponent {
  service: { url: SafeUrl };
  @Input() style: BiolinkBtnConfig;

  @Input() set config(config: { [upiId: string]: string }) {
    let url = this.sanitizer.bypassSecurityTrustUrl(`upi://pay?pa=${config.upiId}&amp;pn=test name&amp;cu=INR`)
    this.service =  {
      url,
    };
  }

  constructor(
    private sanitizer: DomSanitizer,
  ) {}
}
